import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { EntityRelation } from 'app/shared/models/entity-relation.model';
import { EntityRelationsService } from 'app/entities/relations/entity-relations.service';
import { FormErrors } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

@Component({
  selector: 'edit-relationship',
  templateUrl: './edit-relationship.component.html',
  styleUrls: ['./edit-relationship.component.css']
})
export class EditRelationshipComponent implements OnInit {
  editRelationshipSummaryForm: FormGroup;
  entityId: number;
  isLoading = false;
  comment: string;
  relation: EntityRelation;
  commentType: string;

  formErrors = {
    'comment': '',
  };

  validationMessages = {
    'comment': {
      'required': 'Required field value.',
      'maxlength': 'comment is too long.'
    },
  };

  constructor(
    public dialogRef: MdDialogRef<any>,
    private formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private entityRelationsService: EntityRelationsService,
  ) { }

  ngOnInit() {
    this.editRelationshipSummaryForm = this.formBuilder.group({
      comment: ['', [Validators.required, Validators.maxLength(4000)]],
    });
    this.editRelationshipSummaryForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.updateCategorySummaryForm();
  }

  onValueChanged(data?: any) {
    if (!this.editRelationshipSummaryForm) {
      return;
    }
    FormErrors('editRelationshipSummaryForm', this);
  }

  updateCategorySummaryForm(): void {
    if (this.comment) {
      this.editRelationshipSummaryForm.patchValue({
        comment: this.comment,
      });
    }
  }

  onSubmit({ value, valid }): void {
    this.isLoading = true;
    this.relation.commentVO[this.commentType] = value.comment;
    this.entityRelationsService
      .updateExecutiveSummary(this.relation.commentVO, this.relation.detailId, this.relation.entityType)
      .subscribe(
      success => {
        this.isLoading = false;
        if (success.flagResult) {
          this.dialogRef.close(value.comment);
          this.callSnackBarService(success);
        }
      },
      err => {
        this.isLoading = false;
        this.callSnackBarService(err);
      });
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(
      response,
      MessageService.UPDATED_RELATION_SUCCESS,
      MessageService.UPDATED_EDIT_RELATION_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/relations/editrelationship/edit-relationship.component.ts